<script setup>

import priceHiderStore from "../../../../../../Modules/Eshop/Resources/js/composables/priceHiderStore.js";
import {computed} from "vue";
import pinia from '../../../../plugins/pinia.js';
import {usePage} from "@inertiajs/vue3";
const priceHider = priceHiderStore(pinia);
const props = defineProps({
    big: {
        default: false,
        type: Boolean,
    },
    small: {
        default: false,
        type: Boolean,
    },
    moc: {
        default: false,
        type: Boolean,
    }
})

const show = computed(() => {
    if (!usePage().props.customer?.id)
        return true;

    if (props.moc)
        return true;

    return !priceHider?.pricesHidden;
})
</script>

<template>
    <template v-if="show">
        <slot></slot>
    </template>
</template>

<style scoped lang="scss">

</style>
